import { lazy } from 'react';
import { defineGlobalLayer } from '../shell/overlays';
export default defineGlobalLayer({
  id: 'dashboard-create',
  component: lazy(() => import('./dashboard-create.layer')),
});
